import { v4 as uuidv4 } from 'uuid';
import thumb1 from '../assets/img/service1.jpg';
import thumb2 from '../assets/img/service2.jpg';
import thumb3 from '../assets/img/service3.jpg';
import thumb4 from '../assets/img/service4.jpg';
import thumb5 from '../assets/img/service5.jpg';
import thumb6 from '../assets/img/service6.jpg';

export const servicesData = [
    {
        id: uuidv4(),
        slug: 'izolatii-si-hidroizolatii',
        title: 'Izolații și Hidroizolații',
        shortDescription: 'Servicii complete de izolații termice și hidroizolații pentru protecția optimă a clădirii tale.',
        thumbnail: thumb1,
        fullDescription: `
            <h2>Izolații și Hidroizolații Profesionale</h2>
            <p>Work Express oferă servicii complete de izolații termice și hidroizolații pentru orice tip de construcție. Cu o experiență vastă în domeniu, garantăm protecția optimă a clădirii tale împotriva factorilor externi.</p>

            <h3>Serviciile Noastre Includ:</h3>
            <ul>
                <li><strong>Izolații termice exterioare și interioare</strong> - Reducem pierderile de căldură și îmbunătățim eficiența energetică</li>
                <li><strong>Hidroizolații terase și acoperișuri</strong> - Protecție completă împotriva infiltrațiilor de apă</li>
                <li><strong>Izolații fundații și subsol</strong> - Prevenirea umezelii și a problemelor structurale</li>
                <li><strong>Izolații fonice</strong> - Confort acustic superior în spații rezidențiale și comerciale</li>
                <li><strong>Membrane bituminoase și polimerice</strong> - Materiale de cea mai înaltă calitate</li>
            </ul>

            <h3>Beneficiile Izolațiilor Profesionale:</h3>
            <ul>
                <li>Reducerea costurilor de încălzire și climatizare cu până la 40%</li>
                <li>Protecție pe termen lung împotriva infiltrațiilor și condensului</li>
                <li>Creșterea valorii proprietății</li>
                <li>Confort termic și acustic îmbunătățit</li>
                <li>Conformitate cu normele europene de eficiență energetică</li>
            </ul>

            <h3>Materiale Utilizate:</h3>
            <p>Lucrăm doar cu materiale certificate de la producători de renume internațional: polistiren expandat (EPS), polistiren extrudat (XPS), vată minerală, spumă poliuretanică, membrane PVC și TPO.</p>

            <h3>Proces de Lucru:</h3>
            <p>Fiecare proiect începe cu o evaluare tehnică detaliată, urmată de o propunere personalizată. Echipa noastră de specialiști asigură execuția impecabilă, respectând toate normativele în vigoare și termenele stabilite.</p>
        `,
        metaTitle: 'Izolații și Hidroizolații Profesionale București | Work Express',
        metaDescription: 'Servicii profesionale de izolații termice și hidroizolații în București și Ilfov. Echipă certificată, materiale premium, garanție extinsă. Consultanță gratuită!',
        keywords: 'izolații termice, hidroizolații, izolații exterioare, izolații terase, izolații București, izolații case'
    },
    {
        id: uuidv4(),
        slug: 'instalatii-electrice',
        title: 'Instalații Electrice',
        shortDescription: 'Proiectare și execuție instalații electrice moderne, sigure și conforme cu normele în vigoare.',
        thumbnail: thumb2,
        fullDescription: `
            <h2>Instalații Electrice Profesionale</h2>
            <p>Work Express oferă servicii complete de instalații electrice pentru clădiri rezidențiale, comerciale și industriale. Echipa noastră de electricieni autorizați ANRE asigură lucrări de cea mai înaltă calitate, în conformitate cu normele de siguranță.</p>

            <h3>Serviciile Noastre Includ:</h3>
            <ul>
                <li><strong>Proiectare instalații electrice</strong> - Planificare detaliată adaptată nevoilor tale</li>
                <li><strong>Execuție instalații noi</strong> - De la fundație până la finisaje</li>
                <li><strong>Modernizare instalații existente</strong> - Upgrade la standarde moderne de siguranță</li>
                <li><strong>Tablouri electrice și automatizări</strong> - Soluții inteligente de control</li>
                <li><strong>Instalații iluminat interior și exterior</strong> - Design funcțional și estetic</li>
                <li><strong>Verificări și certificate ANRE</strong> - Documentație completă</li>
            </ul>

            <h3>Avantaje Instalații Moderne:</h3>
            <ul>
                <li>Siguranță maximă prin protecții și automatizări moderne</li>
                <li>Eficiență energetică crescută prin soluții LED și automatizare</li>
                <li>Conformitate cu reglementările în vigoare</li>
                <li>Flexibilitate pentru extinderi viitoare</li>
                <li>Suport tehnic pe termen lung</li>
            </ul>

            <h3>Materiale și Echipamente:</h3>
            <p>Utilizăm exclusiv echipamente certificate: cabluri electrice conform SR, tablouri electrice ABB sau Schneider Electric, întrerupătoare automate, prize și întrerupătoare de la producători consacrați.</p>

            <h3>Procedura de Lucru:</h3>
            <p>Realizăm inspecție la fața locului, proiect tehnic detaliat, execuție profesională cu respectarea normelor PE 107 și I7, verificări tehnice și predare cu documentație completă inclusiv certificate ANRE.</p>
        `,
        metaTitle: 'Instalații Electrice București - Electricieni Autorizați ANRE | Work Express',
        metaDescription: 'Instalații electrice profesionale în București. Electricieni autorizați ANRE, proiectare, execuție, modernizări. Materiale certificate, garanție extinsă.',
        keywords: 'instalații electrice, electrician autorizat, instalații electrice București, tablouri electrice, modernizare instalații'
    },
    {
        id: uuidv4(),
        slug: 'vopsitorie-si-tapet',
        title: 'Vopsitorie și Tapet',
        shortDescription: 'Servicii profesionale de vopsitorie interioară și exterioară, aplicare tapet decorativ.',
        thumbnail: thumb3,
        fullDescription: `
            <h2>Vopsitorie și Tapet Profesional</h2>
            <p>Transformăm spațiile tale prin servicii complete de vopsitorie și aplicare tapet. Cu atenție la detalii și utilizând doar materiale premium, garantăm rezultate de lungă durată și un aspect impecabil.</p>

            <h3>Serviciile Noastre Includ:</h3>
            <ul>
                <li><strong>Vopsitorie interioară</strong> - Pereți, tavane, suprafețe diverse</li>
                <li><strong>Vopsitorie exterioară</strong> - Fațade, ziduri, garduri</li>
                <li><strong>Aplicare tapet</strong> - Clasic, texturat, vinilic, din fibră de sticlă</li>
                <li><strong>Vopsitorie decorativă</strong> - Tehnici speciale, efecte texturate</li>
                <li><strong>Pregătire suprafețe</strong> - Șpacluire, șlefuire, primăr</li>
                <li><strong>Lacuire lemn și metal</strong> - Protecție și finisaje profesionale</li>
            </ul>

            <h3>Beneficii:</h3>
            <ul>
                <li>Aspect estetic superior și personalizat</li>
                <li>Protecție împotriva umezelii și mucegaiului</li>
                <li>Finisaje durabile cu rezistență la uzură</li>
                <li>Consultanță în alegerea culorilor și materialelor</li>
                <li>Execuție rapidă fără întreruperea activității</li>
            </ul>

            <h3>Materiale Premium:</h3>
            <p>Lucrăm cu vopsele lavabile de la Caparol, Dulux, Zidex pentru interior și vopsele pentru exterior cu protecție UV. Tapetul provine de la producători renumiți cu garanție de durabilitate.</p>

            <h3>Proces de Lucru:</h3>
            <p>Evaluare și consultanță, pregătire profesională a suprafețelor (șpacluire, șlefuire), aplicare primăr, aplicare vopsea/tapet în 2-3 straturi, curățenie finală. Respectăm programul stabilit și minimizăm disconfortul.</p>
        `,
        metaTitle: 'Vopsitorie și Tapet București - Zugravi Profesioniști | Work Express',
        metaDescription: 'Servicii profesionale de vopsitorie interioară/exterioară și aplicare tapet în București. Materiale premium, finisaje impecabile, prețuri competitive.',
        keywords: 'vopsitorie București, zugravi, aplicare tapet, vopsitorie interioară, vopsitorie exterioară, tapet decorativ'
    },
    {
        id: uuidv4(),
        slug: 'gleturi-si-finisaje',
        title: 'Gleturi și Finisaje',
        shortDescription: 'Finisaje interioare de calitate superioară - gleturi, șpacluiri, șlefuiri profesionale.',
        thumbnail: thumb4,
        fullDescription: `
            <h2>Gleturi și Finisaje Profesionale</h2>
            <p>Work Express oferă servicii specializate de gletuire și finisaje interioare pentru obținerea suprafețelor perfecte, gata de vopsire sau aplicare tapet. Echipa noastră de meșteri experimentați garantează rezultate impecabile.</p>

            <h3>Serviciile Noastre Includ:</h3>
            <ul>
                <li><strong>Gletuire pereți și tavane</strong> - Nivelare perfectă a suprafețelor</li>
                <li><strong>Șpacluire finală</strong> - Suprafețe netede fără imperfecțiuni</li>
                <li><strong>Șlefuire profesională</strong> - Pregătire optimă pentru vopsire</li>
                <li><strong>Montaj și finisare colțare</strong> - Muchii perfecte și durabile</li>
                <li><strong>Reparații fisuri și crăpături</strong> - Consolidare și nivelare</li>
                <li><strong>Finisaje decorative</strong> - Tencuieli decorative, stucaturi</li>
            </ul>

            <h3>Avantaje:</h3>
            <ul>
                <li>Suprafețe perfecte gata de finisare</li>
                <li>Durabilitate crescută a finisajelor ulterioare</li>
                <li>Aspect estetic superior</li>
                <li>Eliminarea imperfecțiunilor și neregularităților</li>
                <li>Consultanță tehnică specializată</li>
            </ul>

            <h3>Materiale Utilizate:</h3>
            <p>Gleturile Knauf, Rigips, Weber pentru diferite aplicații: glet de ipsos pentru interior, glet flexibil pentru zone cu solicitări, șpaclu fin pentru finisaje perfecte. Toate materialele sunt certificate și ecologice.</p>

            <h3>Tehnologie și Execuție:</h3>
            <p>Aplicăm tehnici moderne de gletuire în 2-3 straturi, cu șlefuire intermediară. Utilizăm instrumente profesionale pentru finisaje de cea mai înaltă calitate. Timpul de uscare este respectat conform specificațiilor tehnice.</p>
        `,
        metaTitle: 'Gleturi și Finisaje București - Gletuit Profesional | Work Express',
        metaDescription: 'Servicii profesionale de gletuire și finisaje interioare în București. Suprafețe perfecte, materiale premium, meșteri experimentați. Solicită ofertă!',
        keywords: 'gletuire București, gletuit pereți, șpacluire, finisaje interioare, șlefuire pereți'
    },
    {
        id: uuidv4(),
        slug: 'gips-carton',
        title: 'Gips-Carton',
        shortDescription: 'Montaj și finisare plăci gips-carton - pereți, tavane false, mobilier integrat.',
        thumbnail: thumb5,
        fullDescription: `
            <h2>Sisteme Gips-Carton Profesionale</h2>
            <p>Work Express este specialist în lucrări cu gips-carton, oferind soluții complete pentru compartimentări, tavane false, mobilier integrat și design interior modern. Lucrăm cu materiale Rigips și Knauf de cea mai înaltă calitate.</p>

            <h3>Serviciile Noastre Includ:</h3>
            <ul>
                <li><strong>Pereți și compartimentări</strong> - Rapide, eficiente, cu izolație fonică</li>
                <li><strong>Tavane false</strong> - Simple, în trepte, cu design personalizat</li>
                <li><strong>Mobilier integrat</strong> - Biblioteci, dulapuri, nișe</li>
                <li><strong>Cofraje decorative</strong> - Coloane, arcade, elemente arhitecturale</li>
                <li><strong>Gips-carton rezistent la umiditate</strong> - Pentru băi și bucătării</li>
                <li><strong>Gips-carton ignifug</strong> - Pentru protecție sporită la foc</li>
            </ul>

            <h3>Avantaje Gips-Carton:</h3>
            <ul>
                <li>Montaj rapid și curat, fără moloz</li>
                <li>Flexibilitate în design și configurare</li>
                <li>Izolație fonică și termică excelentă</li>
                <li>Posibilitatea integrării instalațiilor</li>
                <li>Suprafețe perfect plane gata de finisare</li>
                <li>Raport calitate-preț avantajos</li>
            </ul>

            <h3>Materiale și Profile:</h3>
            <p>Utilizăm plăci Rigips și Knauf: standard (alb), rezistent la umiditate (verde), ignifug (roz). Profile metalice CW și UW din oțel galvanizat. Toate materialele sunt certificate conform standardelor europene.</p>

            <h3>Execuție Profesională:</h3>
            <p>Proiectare personalizată, montaj profile metalice, izolație fonică din vată minerală, montaj plăci gips-carton, bandare și gletuire rostri, finisare completă. Garantăm precizie milimetrică și finisaje impecabile.</p>
        `,
        metaTitle: 'Gips-Carton București - Montaj Rigips Profesional | Work Express',
        metaDescription: 'Montaj gips-carton profesional în București - pereți, tavane false, mobilier. Materiale Rigips/Knauf, izolații fonice, execuție rapidă. Ofertă gratuită!',
        keywords: 'gips-carton București, montaj rigips, tavane false, pereți gips-carton, compartimentări'
    },
    {
        id: uuidv4(),
        slug: 'tencuieli-si-sape',
        title: 'Tencuieli și Șape',
        shortDescription: 'Execuție tencuieli interioare și exterioare, șape pentru pardoseli - finisaje durabile.',
        thumbnail: thumb6,
        fullDescription: `
            <h2>Tencuieli și Șape Profesionale</h2>
            <p>Work Express oferă servicii complete de execuție tencuieli și șape pentru orice tip de construcție. Cu experiență vastă și utilaje moderne, garantăm suprafețe perfect plane și durabile în timp.</p>

            <h3>Serviciile Noastre Includ:</h3>
            <ul>
                <li><strong>Tencuieli interioare</strong> - Manual și mecanizat, grosimi variabile</li>
                <li><strong>Tencuieli exterioare</strong> - Rezistente la intemperii</li>
                <li><strong>Șape autonivelante</strong> - Pentru finisaje perfecte</li>
                <li><strong>Șape clasice</strong> - Cu armare și fără armare</li>
                <li><strong>Șape uscate</strong> - Montaj rapid, fără umiditate</li>
                <li><strong>Tencuieli decorative</strong> - Aspect personalizat</li>
            </ul>

            <h3>Avantaje:</h3>
            <ul>
                <li>Suprafețe perfect plane și durabile</li>
                <li>Execuție rapidă cu utilaje profesionale</li>
                <li>Rezistență superioară la uzură</li>
                <li>Protecție termică și fonică</li>
                <li>Bază ideală pentru orice tip de pardoseală</li>
            </ul>

            <h3>Materiale Premium:</h3>
            <p>Tencuieli: Weber, Baumit, Knauf - interior și exterior. Șape: Baumit, Sika, Weber - clasice, autonivelante, cu întărire rapidă. Materiale aditivate pentru performanțe superioare.</p>

            <h3>Tehnologie Modernă:</h3>
            <p>Utilizăm stații de tencuit mecanizat pentru execuție rapidă și uniformă. Șape autonivelante cu pompă pentru suprafețe perfecte. Respectăm grosimile optime și timpii de uscare pentru durabilitate maximă.</p>
        `,
        metaTitle: 'Tencuieli și Șape București - Execuție Profesională | Work Express',
        metaDescription: 'Tencuieli interioare/exterioare și șape profesionale în București. Execuție mecanizată, materiale premium, garanție calitate. Consultanță gratuită!',
        keywords: 'tencuieli București, șape, tencuieli mecanizate, șape autonivelante, tencuieli interioare'
    },
    {
        id: uuidv4(),
        slug: 'montaj-pardoseli',
        title: 'Montaj Pardoseli',
        shortDescription: 'Montaj profesional parchet, laminat, gresie, faianță - finisaje impecabile.',
        thumbnail: thumb1,
        fullDescription: `
            <h2>Montaj Pardoseli Profesional</h2>
            <p>Work Express oferă servicii complete de montaj pardoseli pentru orice tip de spațiu. De la parchet masiv la gresie și faianță, garantăm execuție impecabilă și finisaje de lungă durată.</p>

            <h3>Serviciile Noastre Includ:</h3>
            <ul>
                <li><strong>Montaj parchet masiv</strong> - Clasic, în punt, în spic</li>
                <li><strong>Montaj parchet stratificat</strong> - Sistem click, încleiat</li>
                <li><strong>Montaj laminat</strong> - Rezistent, aspect natural</li>
                <li><strong>Montaj gresie și faianță</strong> - Interior și exterior</li>
                <li><strong>Montaj marmură și granit</strong> - Finisaje premium</li>
                <li><strong>Montaj mochetă și linoleum</strong> - Soluții comerciale</li>
            </ul>

            <h3>Avantaje:</h3>
            <ul>
                <li>Montaj precis cu aliniere perfectă</li>
                <li>Utilizare materiale adezive premium</li>
                <li>Consultanță în alegerea materialelor</li>
                <li>Pregătire profesională a suportului</li>
                <li>Finisaje curate și rapidă punere în funcțiune</li>
            </ul>

            <h3>Tipuri de Pardoseli:</h3>
            <p>Lucrăm cu toate tipurile: parchet masiv stejar, frasin, cireș; parchet stratificat 3 straturi; laminat clasă de trafic intensă; gresie porțelanată și ceramică; piatră naturală; covor PVC și linoleum.</p>

            <h3>Proces de Lucru:</h3>
            <p>Evaluare suport, pregătire șapă și nivelare, montaj cu respectarea dilatațiilor, aplicare rosturi și finisare, tratamente de protecție pentru parchet. Garantăm conformitate cu specificațiile producătorului.</p>
        `,
        metaTitle: 'Montaj Pardoseli București - Parchet, Gresie, Laminat | Work Express',
        metaDescription: 'Montaj profesional parchet, laminat, gresie în București. Meșteri calificați, execuție impecabilă, consultanță specializată. Solicită ofertă personalizată!',
        keywords: 'montaj parchet București, montaj gresie, montaj laminat, montaj faianță, montaj pardoseli'
    },
    {
        id: uuidv4(),
        slug: 'instalare-ac',
        title: 'Instalare AC',
        shortDescription: 'Instalare și service aer condiționat - sisteme moderne de climatizare.',
        thumbnail: thumb2,
        fullDescription: `
            <h2>Instalare Aer Condiționat Profesional</h2>
            <p>Work Express oferă servicii complete de instalare, întreținere și reparații sisteme de aer condiționat. Cu tehnicieni autorizați și echipamente moderne, garantăm funcționare optimă și eficiență energetică.</p>

            <h3>Serviciile Noastre Includ:</h3>
            <ul>
                <li><strong>Instalare aer condiționat split</strong> - Rezidențial și comercial</li>
                <li><strong>Instalare sisteme multi-split</strong> - Pentru mai multe camere</li>
                <li><strong>Instalare sisteme VRV/VRF</strong> - Soluții complexe pentru clădiri</li>
                <li><strong>Service și întreținere periodică</strong> - Menținerea performanțelor</li>
                <li><strong>Reparații și reîncărcare freon</strong> - Intervenții rapide</li>
                <li><strong>Consultanță tehnică</strong> - Alegerea sistemului optim</li>
            </ul>

            <h3>Avantaje:</h3>
            <ul>
                <li>Instalare profesională conform normelor în vigoare</li>
                <li>Garanție extinsă pentru manoperă</li>
                <li>Service post-garanție disponibil</li>
                <li>Eficiență energetică maximă</li>
                <li>Consultanță în alegerea sistemului potrivit</li>
                <li>Prețuri competitive și transparente</li>
            </ul>

            <h3>Branduri Lucrate:</h3>
            <p>Colaborăm cu branduri de top: Daikin, Mitsubishi Electric, LG, Samsung, Gree, Midea, Vaillant. Toate sistemele au clasă energetică A++ sau superioară.</p>

            <h3>Proces Instalare:</h3>
            <p>Evaluare tehnică și dimensionare corectă, montaj unitate interioară și exterioară, execuție instalații frigorifice, teste de etanșeitate și vid, reîncărcare freon, teste funcționare, instruire utilizare. Oferim garanție completă.</p>
        `,
        metaTitle: 'Instalare Aer Condiționat București - Montaj AC Profesional | Work Express',
        metaDescription: 'Instalare aer condiționat în București - Tehnicieni autorizați, branduri premium, garanție extinsă. Service AC, întreținere, reparații. Ofertă rapidă!',
        keywords: 'instalare aer condiționat București, montaj AC, instalare AC, service aer condiționat, reparații AC'
    },
    {
        id: uuidv4(),
        slug: 'hvac',
        title: 'HVAC',
        shortDescription: 'Sisteme complete HVAC - încălzire, ventilație, climatizare pentru confort maxim.',
        thumbnail: thumb3,
        fullDescription: `
            <h2>Sisteme HVAC Complete</h2>
            <p>Work Express proiectează și instalează sisteme HVAC (Heating, Ventilation and Air Conditioning) complete pentru clădiri rezidențiale, comerciale și industriale. Oferim soluții integrate pentru confort termic optim și eficiență energetică maximă.</p>

            <h3>Serviciile Noastre Includ:</h3>
            <ul>
                <li><strong>Proiectare sisteme HVAC</strong> - Calcule termice și bilanț energetic</li>
                <li><strong>Instalare centrale termice</strong> - În condensație, clasice</li>
                <li><strong>Sisteme de ventilație</strong> - Mecanică controlată, recuperare căldură</li>
                <li><strong>Climatizare centralizată</strong> - VRV, VRF, chiller</li>
                <li><strong>Instalații încălzire în pardoseală</strong> - Confort și eficiență</li>
                <li><strong>Automatizări și control</strong> - Sisteme BMS inteligente</li>
            </ul>

            <h3>Avantaje Sisteme HVAC:</h3>
            <ul>
                <li>Confort termic optim în orice anotimp</li>
                <li>Calitate superioară a aerului interior</li>
                <li>Eficiență energetică maximă</li>
                <li>Reducerea costurilor de operare</li>
                <li>Control centralizat și automatizare</li>
                <li>Conformitate cu cerințele de ventilație</li>
            </ul>

            <h3>Soluții Tehnologice:</h3>
            <p>Centrale termice în condensație cu randament >98%, sisteme de ventilație cu recuperare de căldură până la 95%, pompe de căldură aer-apă și aer-aer, sisteme radiante (încălzire/răcire în pardoseală).</p>

            <h3>Proiectare și Execuție:</h3>
            <p>Audit energetic și analiză necesități, proiect tehnic detaliat, execuție instalații conform proiect, balansare și punere în funcțiune, instruire personal, service și mentenanță. Respectăm toate normativele ISCIR și ANRE.</p>
        `,
        metaTitle: 'Sisteme HVAC București - Proiectare și Instalare | Work Express',
        metaDescription: 'Proiectare și instalare sisteme HVAC complete în București. Centrale termice, ventilație, climatizare. Soluții integrate, eficiență energetică. Consultanță!',
        keywords: 'HVAC București, sisteme HVAC, ventilație mecanică, centrale termice, climatizare centralizată'
    },
    {
        id: uuidv4(),
        slug: 'ibix',
        title: 'IBIX',
        shortDescription: 'Curățare și decapare profesională cu tehnologie IBIX - ecologic și eficient.',
        thumbnail: thumb4,
        fullDescription: `
            <h2>Curățare Profesională Tehnologie IBIX</h2>
            <p>Work Express utilizează tehnologia revoluționară IBIX pentru curățare și decapare profesională. Este o metodă ecologică, eficientă și delicată care păstrează integritatea suprafețelor tratate.</p>

            <h3>Serviciile Noastre Includ:</h3>
            <ul>
                <li><strong>Curățare fațade</strong> - Cărămidă, piatră, beton</li>
                <li><strong>Îndepărtare grafitti</strong> - Fără deteriorarea suportului</li>
                <li><strong>Decapare vopsea</strong> - Lemn, metal, beton</li>
                <li><strong>Curățare monumente istorice</strong> - Tehnică delicată aprobată</li>
                <li><strong>Îndepărtare rugină și coroziune</strong> - Suprafețe metalice</li>
                <li><strong>Pregătire suprafețe pentru vopsire</strong> - Aderență optimă</li>
            </ul>

            <h3>Avantaje Tehnologie IBIX:</h3>
            <ul>
                <li>Ecologic - fără substanțe chimice</li>
                <li>Eficient - rezultate rapide</li>
                <li>Delicat - nu deteriorează suportul</li>
                <li>Versatil - pe diverse materiale</li>
                <li>Fără apă - nu produce umiditate</li>
                <li>Silențios - minimizează disconfortul</li>
            </ul>

            <h3>Tehnologia IBIX:</h3>
            <p>Sistemul IBIX utilizează aerosoli cu presiune joasă și particule fine (calcium carbonat, sticlă fin măcinată) care curăță suprafețele fără a le deteriora. Este certificată pentru lucrări pe monumente istorice.</p>

            <h3>Aplicații:</h3>
            <p>Fațade clădiri istorice și moderne, biserici și monumente, suprafețe din cărămidă, piatră, beton, lemn, metal. Curățare industrială, pregătire suprafețe pentru vopsire sau acoperiri speciale. Rezultate verificabile și garanție.</p>
        `,
        metaTitle: 'Curățare IBIX București - Decapare Profesională Ecologică | Work Express',
        metaDescription: 'Curățare și decapare cu tehnologie IBIX în București. Ecologic, eficient, delicat. Fațade, grafitti, vopsea, rugină. Pentru monumente și clădiri moderne.',
        keywords: 'IBIX București, curățare IBIX, decapare ecologică, îndepărtare grafitti, curățare fațade'
    }
];

export const getServiceBySlug = (slug) => {
    return servicesData.find(service => service.slug === slug);
};

export default servicesData;
